import { cx } from '@emotion/css';
import { InfoTwoTone } from '@mui/icons-material';
import { Tooltip } from '@sortlist-frontend/design-system/legacy';
import { Trans } from '@sortlist-frontend/translation';

import { usePublicAppContext } from '_core/context/public-app-context';

export const ForbiddenInfoWarning = (props: { className?: string }) => {
  const { className } = props;
  const { getUrl } = usePublicAppContext();
  const termsUrl = getUrl('legal.terms');

  return (
    <Tooltip
      arrow={true}
      placement="top"
      title={
        <Trans i18nKey="agency:claim.form.forbiddenInfo">
          Adding a phone number or email address in this field violates our
          <span
            data-testid="open-terms-and-conditions"
            onClick={() => window.open(termsUrl, '_self')}
            className="cursor-pointer underline"
            role="none">
            Terms & conditions
          </span>
          and may result in your profile being removed.
        </Trans>
      }>
      <InfoTwoTone
        data-testid="forbidden-info-warning-icon"
        className={cx(className ?? 'text-secondary-500', 'ml-1 p')}
      />
    </Tooltip>
  );
};
